<script setup lang="ts">
import Button from '../Button.vue'

defineProps<{
  // default view shows Clear only
  title: string
  hideActions?: boolean
  hideClear?: boolean
  clearDisabled?: boolean
  showSelectAll?: boolean
  selectAllDisabled?: boolean
  scrollContainerProps?: Record<string, any>
}>()

defineEmits(['clear', 'close', 'select-all'])
</script>

<template>
  <div
    class="root min-w-90 flex h-full w-full flex-col"
    :class="{ 'pb-2': hideActions }"
  >
    <slot name="header">
      <header class="flex items-center justify-between px-4 py-3">
        <h3 class="h3 text-neutral-900">{{ title }}</h3>

        <button
          class="rounded-full p-1 text-neutral-600"
          @click="$emit('close')"
        >
          <div class="i-ph-x-bold h-4 w-4" />
        </button>
      </header>
    </slot>
    <div v-bind="scrollContainerProps" class="flex-1 overflow-y-auto">
      <slot />
    </div>

    <footer
      v-if="!hideActions"
      class="flex justify-end border-t border-neutral-200 px-4 py-3"
    >
      <Button
        v-if="showSelectAll"
        class="px-2 text-sm"
        :disabled="selectAllDisabled"
        variant="text"
        @click="$emit('select-all')"
      >
        Select all
      </Button>
      <Button
        v-if="!hideClear"
        class="px-2 text-sm"
        :disabled="clearDisabled"
        variant="text"
        @click="$emit('clear')"
      >
        Clear
      </Button>
    </footer>
  </div>
</template>

<style scoped>
.root {
  max-height: 62vh;
}
</style>
